if (process.env.NODE_ENV === "production") {
  console.log = () => { };
  console.debug = () => { };
  console.warn = () => { };
}

import React, { createContext, useEffect, useState } from "react";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,

  // useSearchParams 
} from "react-router-dom";

import { loadFromStorage, saveToStorage } from "./utils/cartStorage";

import axios from "axios";
import Home from "./Home";
import Content from "./Content";
import Admin from "./Admin";
import Login from "./Login";
import TopNav from "./TopNav";
import TopMenu from "./TopMenu";
import Onboarding from "./Onboarding";
import FilterMenu from "./FilterMenu";
import ProtectedRoute from "./ProtectedRoute";


axios.defaults.withCredentials = true;

export const PopupContext = createContext();


function Layout({ children }) {
  return (
    <div>
      <TopMenu />
      <div className="content">
        {children}
      </div>
    </div>
  );
}

export default function App() {

  const [showTraining, setShowTraining] = useState(loadFromStorage("showTraining", false));
  const [showEvent, setShowEvent] = useState(loadFromStorage("showEvent", false));
  const [selectedAthlete, setSelectedAthlete] = useState(loadFromStorage("selectedAthlete", "all"));

  useEffect(() => {
    saveToStorage("showTraining", showTraining);
  }, [showTraining]);

  useEffect(() => {
    saveToStorage("showEvent", showEvent);
  }, [showEvent]);

  useEffect(() => {
    saveToStorage("selectedAthlete", selectedAthlete);
  }, [selectedAthlete]);

  return (
    <Router>
      <Layout>
        <TopNav />
        <FilterMenu
          showTraining={showTraining}
          setShowTraining={setShowTraining}
          showEvent={showEvent}
          setShowEvent={setShowEvent}
          selectedAthlete={selectedAthlete}
          setSelectedAthlete={setSelectedAthlete}
        />
        <Routes>
          <Route path="/" element={<Home selectedAthlete={selectedAthlete} showEvent={showEvent} showTraining={showTraining} />} />
          <Route path="/content/:pageKey" element={<Content />} />
          <Route path="/onboarding/:id" element={<Onboarding />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } />
          <Route path="/login" element={<Login />} />
        </Routes>
      </Layout>
    </Router>
  );
}